module.exports = "/assets/data/7787aa91bfdd62700d4dfa006b7c519c-ME5.data.json";